import { render, staticRenderFns } from "./DirectChatModal.vue?vue&type=template&id=1f197839&"
import script from "./DirectChatModal.vue?vue&type=script&lang=js&"
export * from "./DirectChatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports